'use client';

import { BRAND_COLORS } from '@/lib/constants';

export default function GlobalError({
  error: _error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          fontFamily: 'Inter, system-ui, sans-serif',
          backgroundColor: BRAND_COLORS.bg,
          color: BRAND_COLORS.text,
        }}
      >
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
          }}
        >
          <div style={{ maxWidth: '420px', textAlign: 'center' }}>
            <h1
              style={{
                fontSize: '24px',
                fontWeight: 700,
                color: BRAND_COLORS.text,
                marginBottom: '12px',
              }}
            >
              Something went wrong
            </h1>
            <p style={{ fontSize: '16px', color: BRAND_COLORS.muted, marginBottom: '24px' }}>
              An unexpected error occurred. Please try again.
            </p>
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
              <button
                onClick={reset}
                style={{
                  padding: '12px 24px',
                  backgroundColor: BRAND_COLORS.accent,
                  color: BRAND_COLORS.bg,
                  border: 'none',
                  borderRadius: '8px',
                  fontWeight: 700,
                  cursor: 'pointer',
                  fontSize: '14px',
                }}
              >
                Try Again
              </button>
              {/* eslint-disable-next-line @next/next/no-html-link-for-pages -- a full reload is
                  intended: the root layout itself failed, so client navigation is not safe. */}
              <a
                href="/"
                style={{
                  padding: '12px 24px',
                  backgroundColor: 'transparent',
                  color: BRAND_COLORS.text,
                  border: `1px solid ${BRAND_COLORS.muted}`,
                  borderRadius: '8px',
                  fontWeight: 600,
                  textDecoration: 'none',
                  fontSize: '14px',
                }}
              >
                Back to Home
              </a>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
